import { defineComponent as _defineComponent } from 'vue'
import { TipoObra } from '@/constants';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { TextValue } from '@/types/common';


export default /*#__PURE__*/_defineComponent({
  __name: 'TabelaCapitulos',
  setup(__props) {

const store = ConsultaObrasStore();
const { obraTempImpressao: obra, listaCapitulos } = storeToRefs(store);

const items = computed(() =>
  listaCapitulos.value ? listaCapitulos.value : obra.value!.capituloList
);

const itemsSelect = computed(
  () =>
    obra.value?.localizacaoList?.map(({ volume, cdLocalizacaoLivro }) => ({
      text: volume ?? '',
      value: cdLocalizacaoLivro,
    })) ?? []
);

const selected = ref<TextValue>();

onMounted(() => {
  if (itemsSelect.value?.length) {
    selected.value = itemsSelect.value[0];
  }
});

return { __sfc: true,store, obra, listaCapitulos, items, itemsSelect, selected, TipoObra }
}

})